import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import axios from 'axios';
import DovemedLogo from "../../../assets/dovemed_logo.svg";
import { useAuth } from '../../../context/auth';
import { Verification } from '../../dialogs/Verification';
import { NotificationPopper } from "../NotificationPopper/NotificationPopper";
import { AvatarPopper } from '../AvatarPopper/AvatarPopper';
import {
  Logo,
  StyledToolbar,
  StyledButton,
  StyledLink,
  Button,
  DisabledButton
} from './DesktopToolbar.styles';

export function DesktopToolbar() {
  const location = useLocation();
  const { user, authToken, refreshDovePoints, wallet } = useAuth();
  const [verificationOpen, setVerificationOpen] = useState(false);
  const getFreePoints = () => {
    axios.post(`/wallet/api/payments/wallets/get-free-points/`, {}, {headers: { DTOKEN: `${authToken}`}}).then(res => {
        refreshDovePoints();
    })
  }
  return (
    <StyledToolbar adminAccess={user?.isAdmin ? true : false}>
      <Link to={`${process.env.REACT_APP_INTERNAL_URL}`}>
        <Logo src={DovemedLogo} alt="logo" />
      </Link>
      <div>
        {user ? (
          <>
            <StyledLink to={{
              pathname: `${process.env.REACT_APP_INTERNAL_URL}dashboard`,
            }}>Dashboard</StyledLink>
            {user.isAdmin ?
              <>
                <StyledLink to={{
                  pathname: `${process.env.REACT_APP_INTERNAL_URL}my-campaigns`,
                }}>Campaigns</StyledLink>
                <StyledLink to={{
                  pathname: `${process.env.REACT_APP_INTERNAL_URL}clients`,
                }}>Clients</StyledLink>
                <StyledLink to={{
                  pathname: `${process.env.REACT_APP_INTERNAL_URL}support-panel`,
                }}>Support</StyledLink>
              </>
              :
              <StyledLink to={{
                pathname: `${process.env.REACT_APP_INTERNAL_URL}my-campaigns`,
              }}>My campaigns</StyledLink>
            }
            {user.verifiedAccount
              ?
                <>
                  {(wallet && wallet.hasWallet)
                    ?
                      <>
                        {location.pathname === `${process.env.REACT_APP_INTERNAL_URL}create-campaign` 
                          ? <DisabledButton>Create Campaign</DisabledButton>
                          : <StyledButton to={{
                              pathname: `${process.env.REACT_APP_INTERNAL_URL}create-campaign`,
                            }}>Create Campaign</StyledButton>
                        }
                      </>
                    :
                      <Button onClick={getFreePoints}>Free points</Button>
                  }
                </>
              :
                <>
                  <DisabledButton onClick={() => setVerificationOpen(true)}>{(wallet && wallet.hasWallet) ? 'Create Campaign' : ' Free points'}</DisabledButton>
                </>
            }
            <NotificationPopper user={user} authToken={authToken} />
            <AvatarPopper user={user} />
          </>
        ) : (
            <>
              <StyledButton to={{
                pathname: location.pathname,
                state: { openLogin: true }
              }}>Create Campaign</StyledButton>
              <StyledLink to={{
                pathname: location.pathname,
                state: { openLogin: true }
              }}>Login</StyledLink>
            </>
          )}
      </div>
      <Verification open={verificationOpen} setOpen={setVerificationOpen} />
    </StyledToolbar>
  )
}
